var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ebUOh6dCG531",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 300",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.57779,136.19236c0,120.37387,89.66406,78.30737,169.02925,83.97631c25.92878,1.85206,54.61108,21.64222,80.74646,15.61098c10.5251-2.42887,15.56852-25.17316,18.30253-33.3752c11.0118-33.0354,11.08448-76.68353,5.3831-110.8918-7.19831-43.18982-70.54092-24.837-102.27884-29.06872C154.21705,58.7715,68.36357,39.39046,43.4147,48.98619C13.82133,60.36826,10.57779,122.591429,10.57779,149.999999",
    transform: "matrix(.996564-.082828 0.082828 0.996564-11.225499 12.798644)",
    fill: "#ece2aa",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowcase);
export default __webpack_public_path__ + "static/media/showcase.bc11fb8766184c657e369f1d3f3ee3a3.svg";
export { ForwardRef as ReactComponent };